import { query, where } from 'firebase/firestore';

import { FSCollections } from '@providers/firestoreProvider';

export const ordersVendorQuery = (vendorID: string) =>
  query(
    FSCollections.Orders,
    where(`vendors.${vendorID}.statusCode`, '>=', -5)
  );
